"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { c as _c } from "react/compiler-runtime";
import { isBrowser } from '@autoguru/overdrive/dist/utils';
import { invariant } from '@autoguru/utilities';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const sharedContextName = '__AG_EXPAND_SIDE_NAV_CTX__';
const sharedContextObj = '__AG_EXPAND_SIDE_NAV_CTX_OBJ__';
const expandSideNavProviderContext = isBrowser && globalThis[sharedContextObj] || /*#__PURE__*/createContext(null);
export const useExpandSideNav = t0 => {
  const $ = _c(6);
  const {
    stringTokens
  } = t0;
  const contextValue = useContext(expandSideNavProviderContext) || isBrowser && globalThis[sharedContextName];
  let t1;
  if ($[0] !== contextValue || $[1] !== stringTokens) {
    t1 = () => {
      if (stringTokens) {
        contextValue === null || contextValue === void 0 || contextValue.setStringTokens(stringTokens);
      }
    };
    $[0] = contextValue;
    $[1] = stringTokens;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = contextValue === null || contextValue === void 0 ? void 0 : contextValue.setStringTokens;
  let t3;
  if ($[3] !== stringTokens || $[4] !== t2) {
    t3 = [t2, stringTokens];
    $[3] = stringTokens;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t1, t3);
  !(contextValue !== null || process.env.NODE_ENV !== "production") ? process.env.NODE_ENV !== "production" ? invariant(false, "Please have a <ExpandSideNavProvider /> set in your tree") : invariant(false) : void 0;
  return contextValue;
};
export const ExpandSideNavProvider = t0 => {
  const $ = _c(16);
  const {
    children,
    includeAuth,
    asideItems,
    labelClassName,
    stringTokens: incomingStringTokens,
    activeLinkChecker: incomingActiveLinkChecker,
    logoutRedirect,
    logoutUrl
  } = t0;
  const [stringTokens, setStringTokens] = useState(incomingStringTokens);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [viewerAccess, setViewerAccess] = useState(t1);
  const [activeLinkChecker, setActiveLinkChecker] = useState(incomingActiveLinkChecker);
  let t2;
  let t3;
  if ($[1] !== activeLinkChecker || $[2] !== asideItems || $[3] !== includeAuth || $[4] !== labelClassName || $[5] !== logoutRedirect || $[6] !== logoutUrl || $[7] !== stringTokens || $[8] !== viewerAccess) {
    t3 = {
      asideItems,
      labelClassName,
      includeAuth,
      stringTokens,
      viewerAccess,
      logoutRedirect,
      logoutUrl,
      setStringTokens,
      activeLinkChecker,
      setActiveLinkChecker,
      setViewerAccess
    };
    $[1] = activeLinkChecker;
    $[2] = asideItems;
    $[3] = includeAuth;
    $[4] = labelClassName;
    $[5] = logoutRedirect;
    $[6] = logoutUrl;
    $[7] = stringTokens;
    $[8] = viewerAccess;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  t2 = t3;
  const context = t2;
  let t4;
  let t5;
  if ($[10] !== context) {
    t4 = () => {
      if (isBrowser) {
        globalThis[sharedContextName] = context;
      }
    };
    t5 = [context];
    $[10] = context;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== children || $[14] !== context) {
    t6 = /*#__PURE__*/_jsx(expandSideNavProviderContext.Provider, {
      value: context,
      children: children
    });
    $[13] = children;
    $[14] = context;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};